module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevo"
    },
    on: {
      "click": function($event) {
        return _vm.limpiar()
      }
    }
  }, [_vm._v("Nuevo Registro")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-15 fuente-subtitulo"
  }, [_vm._v("USUARIOS CAS")]), _vm._v(" "), _c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.users), function(item) {
    return (_vm.users.length > 0) ? _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nomUsuario))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalNuevo"
      },
      on: {
        "click": function($event) {
          return _vm.ver(item)
        }
      }
    }, [_vm._v("O")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-yellow",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalApp"
      },
      on: {
        "click": function($event) {
          return _vm.verApps(item)
        }
      }
    }, [_vm._v("P")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-brown",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalArea"
      },
      on: {
        "click": function($event) {
          return _vm.verArea(item)
        }
      }
    }, [_vm._v("A")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-yellow",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalRol"
      },
      on: {
        "click": function($event) {
          return _vm.verRols(item)
        }
      }
    }, [_vm._v("R")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.users.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No hay usuario registrado")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error.desError) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Usuario\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.nomUsuario),
      expression: "user.nomUsuario"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text",
      "required": "true",
      "placeholder": "Ingrese Usuario",
      "disabled": _vm.user.idUsuario !== '0'
    },
    domProps: {
      "value": (_vm.user.nomUsuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "nomUsuario", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Password\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.clave),
      expression: "user.clave"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "password",
      "required": "true",
      "placeholder": "Ingrese Clave"
    },
    domProps: {
      "value": (_vm.user.clave)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "clave", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "padding-top": "10px",
      "padding-bottom": "15px"
    }
  }, [_vm._v("\n                      El Password debe contener la primera letra de su nombre y apellido paterno en mayúsculas. Seguido\n                      el guión abajo y por último su número de DNI.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.nuevo) ? _c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.user.nomUsuario == ''
    },
    on: {
      "click": function($event) {
        return _vm.mergeAuth()
      }
    }
  }, [_vm._v("Guardar Cambios")]) : _vm._e(), _vm._v(" "), (_vm.editar) ? _c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Actualizar Cambios")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalApp",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("APLICACIONES DE: " + _vm._s(_vm.user.nomUsuario) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_vm._v("\n                          Aplicación:\n                          "), _vm._v(" "), _c('v-select', {
    staticClass: "fuente m-t-10 m-b-10",
    staticStyle: {
      "width": "100%",
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredAplicaciones,
      "filterable": true,
      "label": "nombreAplicacion",
      "placeholder": "Seleccionar"
    },
    on: {
      "input": _vm.selectAplicacion
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                              Lo siento, no hay aplicaciones que coincidan con \"" + _vm._s(search) + "\".\n                            ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdAplicacion),
      callback: function($$v) {
        _vm.selectedIdAplicacion = $$v
      },
      expression: "selectedIdAplicacion"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13 m-t-27",
    attrs: {
      "type": "button",
      "disabled": _vm.appByUsu.idApp == '0',
      "title": (_vm.appByUsu.idApp == '0') ? 'Para agregar, seleccione una aplicación' : ''
    },
    on: {
      "click": function($event) {
        return _vm.mergeAppByUsu(_vm.user.idUsuario)
      }
    }
  }, [_vm._v("Agregar\n                            +")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_c('br'), _c('br'), _vm._v("\n                          " + _vm._s(_vm.errorApp.desError) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tbApps"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.appById), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descripcion))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.anulaAppByUsu(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])])])]), _vm._v(" "), _vm._m(5)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalRol",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(6), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("ROLES ASIGNADOS A " + _vm._s(_vm.user.nomUsuario) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_vm._v("\n                          Aplicación:\n                          "), _vm._v(" "), _c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10",
    staticStyle: {
      "width": "100%",
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredAppsById,
      "filterable": true,
      "label": "nombreAppById",
      "placeholder": "Seleccionar"
    },
    on: {
      "input": _vm.selectAppById
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [(_vm.appById.length === 0) ? _c('span', [_vm._v("\n                                Lo siento, este usuario no tiene aplicaciones registradas.\n                              ")]) : _c('span', [_vm._v("\n                                Lo siento, no hay aplicaciones que coincidan con \"" + _vm._s(search) + "\".\n                              ")])]
      }
    }]),
    model: {
      value: (_vm.selectedAppById),
      callback: function($$v) {
        _vm.selectedAppById = $$v
      },
      expression: "selectedAppById"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_vm._v("\n                          Rol:\n                          "), _vm._v(" "), _c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10",
    staticStyle: {
      "width": "100%",
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredRoles,
      "filterable": true,
      "label": "nombreRol",
      "placeholder": "Seleccionar"
    },
    on: {
      "input": _vm.selectRol
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [(!_vm.selectedAppById) ? _c('span', [_vm._v("\n                                Primero, debe seleccionar una aplicación.\n                              ")]) : (_vm.rolByApp.length === 0) ? _c('span', [_vm._v("\n                                Lo siento, esta aplicación no tiene roles registrados.\n                              ")]) : _c('span', [_vm._v("\n                                Lo siento, no hay roles que coincidan con \"" + _vm._s(search) + "\".\n                              ")])]
      }
    }]),
    model: {
      value: (_vm.selectedIdRol),
      callback: function($$v) {
        _vm.selectedIdRol = $$v
      },
      expression: "selectedIdRol"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13 m-t-27",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedIdRol,
      "title": (!_vm.selectedIdRol) ? 'Para agregar, primero seleccione de las listas desplegables una Aplicación y luego un Rol' : ''
    },
    on: {
      "click": function($event) {
        return _vm.mergeRolByUsu(_vm.user.idUsuario)
      }
    }
  }, [_vm._v("Agregar\n                            +")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.errorRol.desError) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tbRols"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.rolById), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descripcion))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.anularRolByUsu(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])])])]), _vm._v(" "), _vm._m(8)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalArea",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(9), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("AGREGAR ÁREA PARA " + _vm._s(_vm.user.nomUsuario) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 m-b-10"
  }, [_vm._v("\n                          Flag Seteo:\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaByUsu.flagSeteo),
      expression: "areaByUsu.flagSeteo"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.areaByUsu.flagSeteo) ? _vm._i(_vm.areaByUsu.flagSeteo, null) > -1 : _vm._q(_vm.areaByUsu.flagSeteo, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.areaByUsu.flagSeteo,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.areaByUsu, "flagSeteo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.areaByUsu, "flagSeteo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.areaByUsu, "flagSeteo", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                          Flag Defecto:\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaByUsu.flagDefecto),
      expression: "areaByUsu.flagDefecto"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "1",
      "false-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.areaByUsu.flagDefecto) ? _vm._i(_vm.areaByUsu.flagDefecto, null) > -1 : _vm._q(_vm.areaByUsu.flagDefecto, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.areaByUsu.flagDefecto,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.areaByUsu, "flagDefecto", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.areaByUsu, "flagDefecto", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.areaByUsu, "flagDefecto", $$c)
        }
      }
    }
  }), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 m-b-20"
  }, [_c('v-select', {
    staticClass: "fuente m-t-10 m-b-10",
    staticStyle: {
      "width": "100%",
      "max-width": "550px",
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredAreas,
      "filterable": true,
      "label": "nombreArea",
      "placeholder": "Seleccionar"
    },
    on: {
      "input": _vm.selectArea
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                              Lo siento, no hay áreas que coincidan con \"" + _vm._s(search) + "\".\n                            ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdArea),
      callback: function($$v) {
        _vm.selectedIdArea = $$v
      },
      expression: "selectedIdArea"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "disabled": _vm.areaByUsu.idArea == '0',
      "title": (_vm.areaByUsu.idArea == '0') ? 'Para agregar, seleccione un Área' : ''
    },
    on: {
      "click": function($event) {
        return _vm.mergeAreaByUsu(_vm.user.idUsuario)
      }
    }
  }, [_vm._v("Agregar\n                            +")])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.errorArea.desError) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tbRols"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.areaById), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descripcion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.seteo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.defecto))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          return _vm.anularAreaByUsu(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])])])]), _vm._v(" "), _vm._m(11)])])])])]), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-15 fuente-subtitulo"
  }, [_vm._v("USUARIOS AUTH")]), _vm._v(" "), _c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(12), _vm._v(" "), _c('tbody', [(_vm.users.length > 0) ? _c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', {
    staticClass: "sorting_1"
  }, [_vm._v(_vm._s(_vm.usersAuth.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.usersAuth.nomUsuario))]), _vm._v(" "), _c('td', {
    staticClass: "table-center-header"
  }, [_c('span', {
    staticClass: "badge bg-blue",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modalEditAuth"
    },
    on: {
      "click": function($event) {
        return _vm.verDataAuth(_vm.usersAuth)
      }
    }
  }, [_vm._v("O")])])]) : _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No hay usuario registrado")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error2.desError) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalEditAuth",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(13), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Usuario\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userAuth),
      expression: "userAuth"
    }],
    staticClass: "form-control m-t-10 m-b-10",
    attrs: {
      "type": "text",
      "required": "true",
      "placeholder": "Ingrese Usuario",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.userAuth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userAuth = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                          Password\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claveAuth),
      expression: "claveAuth"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "password",
      "required": "true",
      "placeholder": "Ingrese Clave",
      "disabled": !_vm.userAuth
    },
    domProps: {
      "value": (_vm.claveAuth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claveAuth = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "padding-top": "10px",
      "padding-bottom": "15px"
    }
  }, [_vm._v("\n                      El Password debe contener la primera letra de su nombre y apellido paterno en mayúsculas. Seguido\n                      el guión abajo y por último su número de DNI.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.userAuth == ''
    },
    on: {
      "click": function($event) {
        return _vm.editarAuth()
      }
    }
  }, [_vm._v("Actualizar Cambios")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnularAuth",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                      Se anularán los usuarios CAS y AUTH " + _vm._s(_vm.usersAuth.nomUsuario) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.anularAuth()
      }
    }
  }, [_vm._v("Anular Usuarios")])])])])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "col-md-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalAnularAuth",
      "disabled": this.users.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.verAnular(_vm.usersAuth)
      }
    }
  }, [_vm._v("Anular Usuarios")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v("MANTENIMIENTO DE USUARIOS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "NOMBRE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("NOMBRE\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "MODIFICAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("MODIFICAR PASSWORD\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "DETALLE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("APLICACIÓN\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "DETALLE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ÁREA")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "DETALLE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ROL")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tbApps",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM\n                                ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "APP",
      "aria-controls": "tbApps",
      "tabindex": "0"
    }
  }, [_vm._v("APLICACION")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tbApps",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM\n                                ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "APP",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ROL")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM\n                                ")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "APP",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ÁREA")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "APP",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("SETEO")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "APP",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("DEFECTO")]), _vm._v(" "), _c('th', {
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tbRols",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "NOMBRE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("NOMBRE\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "MODIFICAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("MODIFICAR PASSWORD\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEA ANULAR LOS USUARIOS?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-275e4fa9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Usuarios.vue
// module id = 331
// module chunks = 1